<template>
  <div class="login">
    <div class="wrapper">
      <div class="dialog dialog-shadow" style="display: block; margin-top: -362px;">
        <div class="title"></div>
        <div class="content">
          <ul class="common-form" style="display: flex; flex-direction: column;">
            <li>
              <div class="input">
                <input type="text" v-model="ruleForm.userName" placeholder="手机号码">
              </div>
            </li>
            <li>
              <div class="input">
                <input type="password" v-model="ruleForm.userPwd" @keyup.enter="login" placeholder="登录密码">
              </div>
            </li>
            <li style="text-align: right" class="pr">
              <el-checkbox class="auto-login" v-model="autoLogin">记住密码</el-checkbox>
              <a href="javascript:;" class="register" @click="toRegister">立即注册</a>
              <a href="javascript:;" style="padding: 1px 0 0 10px" @click="getPassword">忘记密码 ?</a>
            </li>
          </ul>
          <!--登陆-->
          <div style="margin-top: 25px">
            <y-button :text="logintxt"
              :classStyle="ruleForm.userPwd && ruleForm.userName && logintxt === '登录'?'main-btn':'disabled-btn'"
              @btnClick="login" style="margin: 0;width: 100%;height: 48px;font-size: 18px;line-height: 48px"></y-button>
          </div>
          <!--返回-->
          <div>
            <y-button text="返回" @btnClick="login_back"
              style="marginTop: 10px;marginBottom: 15px;width: 100%;height: 48px;font-size: 18px;line-height: 48px">
            </y-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import YButton from '/components/YButton'
  import graceChecker from '../../../common/graceChecker.js';
  import {mapState} from 'vuex'
  import {
    setStore,
    getStore,
    removeStore
  } from '/utils/storage.js'
  export default {
    data() {
      return {
        cart: [],
        ruleForm: {
          userName: '',
          userPwd: '',
          errMsg: ''
        },
        autoLogin: false,
        logintxt: '登录'
      }
    },
    computed: {
      ...mapState(['user'])
    },
    methods: {
      open(t, m) {
        this.$notify.info({
          title: t,
          message: m
        })
      },
      message(m) {
        this.$message.error({
          message: m
        })
      },
      getRemembered() {
        var judge = getStore('remember')
        if (judge === 'true') {
          this.autoLogin = true
          this.ruleForm.userName = getStore('rusername')
          this.ruleForm.userPwd = getStore('rpassword')
        }
      },
      rememberPass() {
        if (this.autoLogin === true) {
          setStore('remember', 'true')
          setStore('rusername', this.ruleForm.userName)
          setStore('rpassword', this.ruleForm.userPwd)
        } else {
          setStore('remember', 'false')
          removeStore('rusername')
          removeStore('rpassword')
        }
      },
      toRegister() {
        this.$yxz.to('/register')
      },
      // 登录返回按钮
      login_back() {
        this.$yxz.back();
      },
      getPassword() {
        this.$yxz.to('/resetPassword')
        // this.$yxz.to('/3Dmodel')
      },
      login() {
        this.logintxt = '登录中...'
        this.rememberPass()
        //定义表单规则
        var rule = [{
            name: 'account',
            checkType: 'notnull',
            errorMsg: '请输入用户名'
          },
          {
            name: 'password',
            checkType: 'string',
            checkRule: '6,16',
            errorMsg: '密码至少6位'
          }
        ];
        //进行表单检查
        var formData = {
          account: this.ruleForm.userName,
          password: this.ruleForm.userPwd
        }
        var checkRes = graceChecker.check(formData, rule);
        if (checkRes) {
          this.$api.post({
            url: '/login',
            data: {
              loginName: this.ruleForm.userName,
              loginPassword: this.ruleForm.userPwd,
              uuid: Date.now()
            },
            // isToken: false
          }).then(res => {
            if (res.code === 200) {
              setStore('token', res.token)
              // setStore('userId', res.userId)
              this.$store.commit('common/resetNav');
              this.$yxz.to('/home')
              this.$api.post({
                url: '/imRegister',
                data: {
                  uniPlatform: "web"
                }
              }).then((e)=>{
                console.log('e: ',e);
              })
              //登陆成功移除添加的提示
              let newElement = document.getElementById('tip-browser-compatibility');
              if (newElement) {
                let parentElement = newElement.parentNode;
                parentElement.removeChild(newElement);
              }
            } else {
              this.logintxt = '登录'
              this.$yxz.msg(res.msg)
              return false
            }
          })
        } else {
          this.$yxz.msg(graceChecker.error);
          this.logintxt = '登录'
        }
      }
    },
    mounted() {
      this.$yxz.title("医小智 - 登录")
      this.getRemembered()
      var userAgent = navigator.userAgent;
      this.isChrome = /Chrome\/(\d+\.\d+\.\d+\.\d+)/.test(userAgent) && !/Edg|Quark/.test(userAgent);
      if (!this.isChrome) {
      // if (userAgent.indexOf("Chrome") == -1) {
      	let newElement = document.createElement('div')
      	newElement.innerHTML = `
        <div id="tip-browser-compatibility" style="background: #fff9ea;color: #ff9a43;position: fixed;top: 0;left: 0;width: 100vw;padding: 15px;font-size: 18px;">
          注意：本系统最佳兼容chrome浏览器，其他浏览器可能出现异常。<a href="https://www.google.cn/chrome/">点此下载chrome浏览器</a>
        </div>      `
      	document.body.appendChild(newElement)
      }
      // this.open('登录提示', '测试体验账号密码：test | test')
    },
    components: {
      YButton
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
  * {
    box-sizing: content-box;
  }

  .login {
    overflow-x: hidden;
    overflow-y: hidden;

    .wrapper {
      background: url(/static/images/bg.png) repeat;
      background-size: 100px;
      min-height: 800px;
      min-width: 630px;
    }

    .input {
      height: 50px;
      display: flex;
      align-items: center;

      input {
        font-size: 16px;
        width: 100%;
        height: 100%;
        padding: 10px 15px;
        box-sizing: border-box;
        border: 1px solid #ccc;
        border-radius: 6px;
      }
    }

  }

  .login .dialog {
    width: 450px;
    border: 1px solid #dadada;
    border-radius: 8px;
    top: 50%;
    left: 50%;
    margin-left: -225px;
    position: absolute;

    .title {
      background: linear-gradient(#fff, #f5f5f5);
      overflow: visible;
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
      position: relative;
      background-image: url(/static/images/bg_login.png);
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      height: 225px;
      box-shadow: none;
      border-radius: 8px 8px 0px 0px;
      margin-bottom: 30px;
    }

    .content {
      padding: 0px 40px 30px;
      height: auto;

      .common-form {
        li {
          clear: both;
          margin-bottom: 15px;
          position: relative;
        }
      }
    }

  }

  .login .dialog-shadow {
    -webkit-box-shadow: 0 9px 30px -6px rgba(0, 0, 0, 0.2),
      0 18px 20px -10px rgba(0, 0, 0, 0.04), 0 18px 20px -10px rgba(0, 0, 0, 0.04),
      0 10px 20px -10px rgba(0, 0, 0, 0.04);
    -moz-box-shadow: 0 9px 30px -6px rgba(0, 0, 0, 0.2),
      0 18px 20px -10px rgba(0, 0, 0, 0.04), 0 18px 20px -10px rgba(0, 0, 0, 0.04),
      0 10px 20px -10px rgba(0, 0, 0, 0.04);
    box-shadow: 0 9px 30px -6px rgba(0, 0, 0, 0.2),
      0 18px 20px -10px rgba(0, 0, 0, 0.04), 0 18px 20px -10px rgba(0, 0, 0, 0.04),
      0 10px 20px -10px rgba(0, 0, 0, 0.04);
  }

  @media screen and (min-width: 737px),
  screen and (-webkit-max-device-pixel-ratio: 1.9) and (max-width: 736px) and (min-device-width: 737px) {
    .wrapper {
      background: url(/static/images/bg.png) repeat-x;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background-color: red;
    }

    .dialog {
      background: url(/static/images/dialog-gray-bg.png) #fff bottom repeat-x;
      border-radius: 12px;
      display: none;
      margin: -163px 0 0 -218px;
      width: 436px;
      position: fixed;
      left: 50%;
      top: 50%;
    }

    .common-form li {
      clear: both;
      margin-bottom: 15px;
      position: relative;
    }

    .auto-login {
      position: absolute;
      top: 0px;
      left: 2px;
      color: #999;
    }

    .register {
      padding: 1px 10px 0;
      border-right: 1px solid #ccc;
    }

    .border {
      margin-top: 10px;
      border-bottom: 1px solid #ccc;
    }

  }
</style>



// WEBPACK FOOTER //
// login.vue?521e87e4